<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path d="M9.55 18.0001L3.85 12.3001L5.275 10.8751L9.55 15.1501L18.725 5.9751L20.15 7.4001L9.55 18.0001Z"
        fill="white"/>
</svg>
</template>
